export const formatDate = (d: string) => {
  const date = new Date(d);
  const day = date.getUTCDate().toString().padStart(2, '0');
  const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const year = date.getUTCFullYear().toString();

  return `${day}/${month}/${year}`;
};
